<template>
    <v-btn flat :disabled="!valid" @click="onClick" small color="success">
        <v-icon>save</v-icon>
        {{typeof buttonText === 'undefined' ? translater.__('Save') : translater.__(buttonText)}}
    </v-btn>
</template>

<script>
    export default {
        name: 'SuccessButton',
        props: ['valid', 'onClick', 'buttonText'],

        computed: {
            translater: {
                get()
                {
                    return this.$store.getters['translate/translater'];
                }
            }
        },

       

    }
</script>